import React, { useEffect } from "react";
import "./App.css";
import { createLink, readParamsFromURL, redirect } from "./utils";
import { PRODUCTION_URL } from "./enviroment";
import { ApiConsumer } from "./services/ApiConsumer";

function App() {
  const {
    partner,
    instance,
    game,
    token,
    userUuid,
    sessionId,
    lang,
    jackpot,
    currency,
  } = readParamsFromURL();

  const [isMissingRequiredParameters] = React.useState(
    !partner || !instance || !game
  );
  const [isErrorOnApi, setIsErrorOnApi] = React.useState(false);

  useEffect(() => {
    if (isMissingRequiredParameters) {
      return;
    }

    const url = createLink(
      jackpot !== null && jackpot
        ? PRODUCTION_URL + "/Jackpots"
        : PRODUCTION_URL,
      {
        game,
        instance,
        partner,
        token,
        userUuid,
        sessionId,
        lang,
        currency,
      }
    );

    ApiConsumer.getUrl(url)
      .then((response) => {
        redirect(response.url);
      })
      .catch((error: any) => {
        setIsErrorOnApi(true);
        console.log(error);
      });
  }, [
    game,
    instance,
    isMissingRequiredParameters,
    partner,
    sessionId,
    token,
    userUuid,
    currency,
    jackpot,
    lang,
  ]);

  return (
    <div className="App">
      <header className="App-header">
        <p>
          {isMissingRequiredParameters
            ? "Missing required parameters"
            : isErrorOnApi
            ? "Error on loading page"
            : "Redirecting..."}
        </p>
      </header>
    </div>
  );
}

export default App;
